// Deployment Norms upload template — the client-side sample workbook.
//
// THREE SYNC POINTS. Changing a header here means changing all three:
//   1. this file (the downloadable sample)
//   2. the backend parser, src/utils/helper.util.ts
//      parseDeploymentNormsFileToJson (locates the header row by the
//      'Norm Code' cell, maps BY HEADER TEXT — aliases cover the source
//      workbook's 'Application Fcator' typo)
//   3. the backend export builder,
//      src/machinery-equipment/helpers/deployment-norms-export.helper.ts
//
// VERSIONED, per-norm-code: the file's rows for one Norm Code are a candidate
// NEW full-matrix version effective from the COMMIT instant. An identical
// matrix is No Change; codes absent from the file are untouched.
//
// FACTORS ARE FRACTIONS here (0.05 means 5%), unlike the equipment-rates
// sheet's whole-number percentages — this matches the source workbook
// (Machinery Norms-V1.xlsx) so it uploads as-is.
//
// Total Working HRS is COMPUTED, never uploaded. The parser ignores a stray
// hours column, so the raw V1 workbook round-trips cleanly.

export const DEPLOYMENT_NORM_TEMPLATE_HEADERS = [
  "Norm Code",
  "Asset Code",
  "Equipment Name",
  "Non Production Hours Factor",
  "Effective Utilization Factor",
  "Application Factor",
  "Production Norm Unit",
  "Prod. Norm HRS",
];

export const DEPLOYMENT_NORM_TEMPLATE_COL_WIDTHS = [
  { wch: 14 },
  { wch: 14 },
  { wch: 34 },
  { wch: 24 },
  { wch: 24 },
  { wch: 18 },
  { wch: 20 },
  { wch: 16 },
];

/**
 * One line of a B3.1.1-style matrix, factors as fractions. Asset Code left
 * blank — the name resolves against the Asset Master; fill the code
 * (AST-0001 style) when two machines share a name.
 */
export const DEPLOYMENT_NORM_TEMPLATE_SAMPLE_ROWS = [
  ["B3.1.1", "", "Drill Jumbo", 0.05, 1, 1, "Cum/Hr", 50],
];

export const DEPLOYMENT_NORM_TEMPLATE_INSTRUCTIONS = [
  ["Equipment Norms — Upload Instructions"],
  [""],
  ["Norm Code", "REQUIRED. The BoQ norm this row belongs to (e.g. B3.1.1). All rows sharing a code form ONE matrix — the norm's complete equipment deployment."],
  ["Equipment Name", "REQUIRED. Matched to EXISTING machines in Assets > Asset Master (ignoring case and extra spaces). A machine that does not exist there is a row ERROR: create it in the Asset Master first, then re-upload."],
  ["Asset Code", "Optional — the asset's code (e.g. AST-0012). Fill it when two machines share a name; the code makes the match exact."],
  [""],
  ["Factors", "FRACTIONS, not percentages: 0.05 means 5%. Blank factors use the defaults — Non Production Hours 0, Effective Utilization 1, Application 1."],
  ["Production Norm Unit", "The output unit per hour, e.g. Cum/Hr. Blank defaults to Cum. Only the part before the '/' is stored; '/Hr' is display."],
  ["Prod. Norm HRS", "Output units per hour. 0 (or blank) means the equipment is CONSIDERED in the norm but not deployed — the row is kept, it just earns no hours."],
  [""],
  ["Versioning", "Equipment norms are EFFECTIVE-DATED. Committing this upload creates a NEW version — effective from the commit instant — for each Norm Code whose matrix changed. An identical matrix is No Change; codes not in the file are untouched."],
  [""],
  ["Total Working HRS", "COMPUTED, never uploaded: hours = (qty × AF) / (Prod. Norm × EUF) × (1 + NPF). Do not include an hours column — it is ignored if present."],
];
